import {svgIconWrapper} from '../svg-icon-wrapper';

import GlobeCursorRegular from './globe-cursor-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GlobeCursorRegular {...validProps} />;
}

SvgComponent.iconName = 'globeCursorRegular';

export const GlobeCursorRegularIcon = svgIconWrapper(SvgComponent);
